import React from "react";
import { compose } from "recompose";
import { DocumentRenderer } from "components";
import { Trans } from "react-i18next";
import withData from "./withData";
import { withSelectedOrganisation } from "components/withSelectedOrganisation";
import MainHeader from "./MainHeader";
import LineItems from "./LineItems";
import HeaderData from "./HeaderData";
import { convertUTCToLocal } from "services/util";

export const BillDocument = ({
  item,
  contact,
  organisation,
  taxRates,
  settings,
  t,
  ...props
}) => {
  return (
    <DocumentRenderer {...props}>
  
    <div className="container-fluid my-3" >
  
      <MainHeader item={item} company={organisation} client={contact} taxRates={taxRates} t={t} settings={settings} doc_name={'Bill'} hideAttention={true} logo={props.selectedOrganisation.logo}>
        <HeaderData className="mb-1" label={`Date`} value={item.DateString} />
        <HeaderData className="mb-1" label={`Time`} value={convertUTCToLocal(item.UpdatedDateUTC)} />
        <HeaderData className="mb-1" label="Reference" value={item.Reference || item.InvoiceNumber} />
        <HeaderData className="mb-1" label="Supply Date" value={item.ExpectedPaymentDateString} />
      </MainHeader>
     
      <LineItems invoice={item} taxRates={taxRates} lang={props.language}/>
  
        <div className="text-center">
          <strong>
            <Trans>This is not a tax invoice</Trans>
          </strong>
        </div>
      </div>
    </DocumentRenderer>
  )
};

const enhance = compose(withData, withSelectedOrganisation());

export default enhance(BillDocument);
